function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiemensLogoPetrol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1000px",
    height: "159px",
    viewBox: "0 0 1000 159",
    style: {
      enableBackground: "new 0 0 1000 159"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BoundingBox"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "0,159 1000,159 1000,0 0,0 0,0  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "SIEMENS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#009999"
    },
    d: "M3.086,152.537V122.46 c17.119,5.388,32.267,8.082,45.444,8.082c18.193,0,27.291-4.809,27.291-14.42c0-3.583-1.324-6.594-3.978-9.032 c-2.714-2.586-9.665-6.171-20.835-10.764c-20.042-8.241-33.111-15.269-39.19-21.082C3.939,67.571,0,57.895,0,46.202 C0,31.144,5.74,19.667,17.212,11.78C28.557,3.962,43.33,0.057,61.554,0.057c10.041,0,24.574,1.848,43.583,5.549v28.933 c-14.144-5.65-27.273-8.469-39.403-8.469c-17.081,0-25.621,4.69-25.621,14.091c0,3.514,1.72,6.38,5.165,8.602 c2.865,1.798,10.759,5.596,23.665,11.406c18.583,8.253,30.954,15.427,37.118,21.529c7.314,7.238,10.978,16.604,10.978,28.084 c0,16.501-7.177,29.088-21.521,37.761c-11.621,7.033-26.69,10.535-45.198,10.535C34.69,158.078,18.942,156.237,3.086,152.537 L3.086,152.537z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#009999"
    },
    points: "141.063,2.704 141.063,2.704 183.603,2.704  183.603,155.001 141.063,155.001  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#009999"
    },
    points: "222.616,155.001 222.616,2.704 331.721,2.704  331.721,30.25 263.616,30.25 263.616,64.639 322.898,64.639 322.898,89.765 263.616,89.765 263.616,125.906 333.476,125.906  333.476,155.001 222.616,155.001  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#009999"
    },
    points: "361.247,155.001 361.247,2.704 416.402,2.704  454.721,100.015 494.001,2.704 546.39,2.704 546.39,155.001 506.056,155.001 506.056,47.171 461.392,156.547 435.023,156.547  391.219,47.171 391.219,155.001 361.247,155.001  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#009999"
    },
    points: "585.411,155.001 585.411,2.704 694.514,2.704  694.514,30.25 626.415,30.25 626.415,64.639 685.695,64.639 685.695,89.765 626.415,89.765 626.415,125.906 696.28,125.906  696.28,155.001 585.411,155.001  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#009999"
    },
    points: "724.271,155.001 724.271,2.704 773.575,2.704  825.883,104.655 825.883,2.704 855.847,2.704 855.847,155.001 807.943,155.001 754.247,51.678 754.247,155.001 724.271,155.001  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#009999"
    },
    d: "M886.047,152.537V122.46 c16.974,5.388,32.12,8.082,45.452,8.082c18.195,0,27.282-4.809,27.282-14.42c0-3.583-1.289-6.594-3.854-9.032 c-2.728-2.586-9.708-6.171-20.945-10.764c-19.982-8.173-33.064-15.198-39.199-21.082c-7.875-7.605-11.807-17.317-11.807-29.146 c0-14.993,5.726-26.432,17.21-34.319c11.328-7.818,26.118-11.723,44.344-11.723c10.247,0,23.525,1.627,39.81,4.896l3.761,0.653 v28.933c-14.146-5.65-27.313-8.469-39.508-8.469c-17.016,0-25.503,4.69-25.503,14.091c0,3.514,1.711,6.38,5.147,8.602 c2.73,1.729,10.656,5.529,23.778,11.406c18.442,8.253,30.787,15.427,37.005,21.529c7.325,7.238,10.98,16.604,10.98,28.084 c0,16.501-7.135,29.088-21.406,37.761c-11.689,7.033-26.796,10.535-45.301,10.535 C917.646,158.078,901.891,156.237,886.047,152.537L886.047,152.537z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiemensLogoPetrol);
export default __webpack_public_path__ + "static/media/siemens-logo-petrol.d3a18e49a7a709f89ea267ca1669a9db.svg";
export { ForwardRef as ReactComponent };